<template>
  <div class="navbar-header d-sm-block d-none">
    <b-link :to="{name: 'prs-main'}">
    <ul class="nav navbar-nav">
      <li class="nav-item" >
        <span class="navbar-brand">
          <span class="brand-logo">
            <b-img :src="appLogoImage" alt="logo" />
          </span>
          <h2 class="brand-text mb-0">
            <b> {{ appName }} </b>
          </h2>
        </span>
      </li>
    </ul>
    </b-link>
  </div>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
    BImg,
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
}
</script>

<style scoped>
.brand-logo img {
  max-width: 30%;
  height: auto;
}
</style>
